import type { LifecycleStep } from "../aidwops.types";
import "./ExpertQueue.scss";

const MARK: Record<LifecycleStep["state"], string> = {
    done: "✓",
    current: "●",
    upcoming: "○",
    staged: "◐",
    failed: "✕",
    rejected: "✕",
    skipped: "–",
};

const STATE_TEXT: Record<LifecycleStep["state"], string> = {
    done: "Done",
    current: "In progress",
    upcoming: "Next",
    staged: "Staged",
    failed: "Failed",
    rejected: "Rejected",
    skipped: "Skipped",
};

/**
 * Where the request is, as the backend tells it: every step with its state, who did it and when.
 * The steps are the backend's own (`lifecycle.steps`), so a new step there shows up here without a change.
 */
export function LifecycleStepper({ steps }: { steps: LifecycleStep[] }) {
    return (
        <ol className="lifecycle-steps" aria-label="Progress of this request">
            {steps.map((step) => {
                const meta = [
                    step.by,
                    step.at ? new Date(step.at).toLocaleString() : null,
                ]
                    .filter(Boolean)
                    .join(" · ");

                return (
                    <li
                        key={step.key}
                        className={`lifecycle-step lifecycle-step--${step.state}`}
                    >
                        <span className="lifecycle-step-mark" aria-hidden="true">
                            {MARK[step.state]}
                        </span>
                        <div className="lifecycle-step-body">
                            <div className="lifecycle-step-label">
                                {step.label}
                                <span className="lifecycle-step-state">
                                    {STATE_TEXT[step.state]}
                                </span>
                            </div>
                            {meta && (
                                <div className="lifecycle-step-meta">{meta}</div>
                            )}
                            {step.detail && (
                                <div className="lifecycle-step-detail">
                                    {step.detail}
                                </div>
                            )}
                        </div>
                    </li>
                );
            })}
        </ol>
    );
}

export default LifecycleStepper;
